module.exports = __webpack_public_path__ + "static/media/nick.322980b4.jpeg";